import {runInAction} from 'mobx'
import { BaseUIComponentProps } from '../../components/metadata-components/BaseUIComponent';
import { IDomainData } from '../../datatypes';
import {addContextualError, removeContextualError, printErrors, removeErrors} from '../error-utils'


function validateUI(props:BaseUIComponentProps){
    runInAction(() =>{
      removeErrors(props.formBean);
      let isValid = true;
      for(let v of props.formBean.validators){
        try {
          let valid = v();
          if (!valid) isValid = false;
        } catch(err){
          console.warn(err)
        }
      }
      props.formBean.hasError = !isValid;

    });
    if (props.formBean.hasError){
        addContextualError(props.formBean, 'formError', 'There are errors on the form, please fix the errors and try again.')
        printErrors(props.formBean, []);
        throw Error('UI validation failed'); // throw error to stop calling remaining event handlers. 
        // TODO: use chained event handler pattern, reserve Error for true errors !!!
    }else{
      removeContextualError(props.formBean, 'formError');
    }
}

/**
 * Select an Item based on ctx.listBinding. view: cp-my-accounts
 * Example: (ctx.listBinding: "CustomerAccount")
 * This is only to be used for a Button event on a RepeatableSection
 * @param {*} props 
 */
function selectItem(props:BaseUIComponentProps) {
    // @ts-ignore
  let ctx = (props  as RepeatableChildProps).ctx;
  runInAction(() =>{
    ((ctx[ctx.listBinding]).data as IDomainData)["_selected"] = true;
  });
}

/**
 * Handles the Print click button event.
 */
function handlePrintEvent() {
  window.print();
}

export const PredefinedEventHandlerTypeA= {} as {[key:string]:typeof validateUI|typeof handlePrintEvent}

PredefinedEventHandlerTypeA.validateUI = validateUI;
PredefinedEventHandlerTypeA.selectItem = selectItem;
PredefinedEventHandlerTypeA.handlePrintEvent = handlePrintEvent;
